module.exports = __webpack_public_path__ + "static/media/Shield-white.673ca530.svg";